import { type BookChapter, type SearchMatch } from './book';

const SNIPPET_RADIUS = 40;
const DEFAULT_LIMIT = 50;

function snippetAround(text: string, matchIndex: number, queryLength: number): string {
  const start = Math.max(0, matchIndex - SNIPPET_RADIUS);
  const end = Math.min(text.length, matchIndex + queryLength + SNIPPET_RADIUS);
  const core = text.slice(start, end).trim();
  return `${start > 0 ? '…' : ''}${core}${end < text.length ? '…' : ''}`;
}

/**
 * Find every paragraph containing `query` (case-insensitive), in reading order, capped at `limit`.
 * Each match carries the chapter/paragraph it lives at so the player can jump straight to it.
 */
export function searchBook(
  chapters: readonly BookChapter[],
  query: string,
  limit: number = DEFAULT_LIMIT,
): SearchMatch[] {
  const needle = query.trim().toLowerCase();
  if (needle === '') return [];

  const matches: SearchMatch[] = [];
  for (let c = 0; c < chapters.length; c++) {
    const chapter = chapters[c];
    for (let p = 0; p < chapter.paragraphs.length; p++) {
      const text = chapter.paragraphs[p];
      const at = text.toLowerCase().indexOf(needle);
      if (at === -1) continue;
      matches.push({
        chapter: c,
        paragraph: p,
        chapterLabel: chapter.label,
        snippet: snippetAround(text, at, needle.length),
      });
      if (matches.length >= limit) return matches;
    }
  }
  return matches;
}
